const createSelectChangeHandler = _ref => {
  let {
    onChange
  } = _ref;
  return _ref2 => {
    let {
      selected
    } = _ref2;
    onChange(selected);
  };
};
export { createSelectChangeHandler };